import React from 'react'
import './footer.css'

import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa'

function Footer() {
  return (
    <footer id='footer'>
      <a href='#' className='footer__logo'>
        Mamt4real
      </a>

      <ul className='permalinks'>
        <li>
          <a href='#'>Home</a>
        </li>
        <li>
          <a href='#about'>About</a>
        </li>
        <li>
          <a href='#experience'>Experience</a>
        </li>
        <li>
          <a href='#services'>Services</a>
        </li>
        <li>
          <a href='#portfolio'>Portfolio</a>
        </li>
        <li>
          <a href='#testimonials'>Testimonials</a>
        </li>
        <li>
          <a href='#conatct'>Contact</a>
        </li>
      </ul>

      <div className='footer__socials'>
        <a href='https://facebook.com/mamt4real'>
          <FaFacebook />
        </a>
        <a href='https://instagram.com/mamt4real'>
          <FaInstagram />
        </a>
        <a href='https://twitter.com/mamt4real'>
          <FaTwitter />
        </a>
      </div>

      <div className='footer__copyright'>
        <small>&copy; Mamt4real 2022. All rights reserved</small>
      </div>
    </footer>
  )
}

export default Footer
